import { addLeadArabicTranslations } from './addLeadTranslations';
import { salesArabicTranslations, salesEnglishTranslations } from './translations';
import { targetsArabicTranslations, targetsEnglishTranslations } from './targetsTranslations';
import { operationsArabicTranslations, operationsEnglishTranslations } from './operationsTranslations';
import { employeeArabicTranslations, employeeEnglishTranslations } from './employeeTranslations';
import { supplementArabicTranslations, supplementEnglishTranslations } from './supplementTranslations';
import { finalOperationsArabicTranslations, finalOperationsEnglishTranslations } from './finalOperationsTranslations';
import { finalEmployeeArabicTranslations, finalEmployeeEnglishTranslations } from './finalEmployeeTranslations';
import { leadMovementArabicTranslations, leadMovementEnglishTranslations } from './leadMovementTranslations';
import { dashboardAuditArabicTranslations, dashboardAuditEnglishTranslations } from './dashboardAuditTranslations';
import { targetsAuditArabicTranslations, targetsAuditEnglishTranslations } from './targetsAuditTranslations';
import { shellAuditArabicTranslations, shellAuditEnglishTranslations } from './shellAuditTranslations';
import { operationsAuditArabicTranslations, operationsAuditEnglishTranslations } from './operationsAuditTranslations';

// Authored UI copy only; API identifiers and customer content stay untouched.
export const salesArabicCatalog: Record<string,string> = {
 'View lead history': 'عرض الهيستوري',
 'Distributed at least once': 'تم توزيعه مرة على الأقل',
 'Not distributed yet': 'لم يُسجل له توزيع بعد',
 'Currently assigned': 'مسندون حاليًا',
 'Current salesperson': 'الموظف المسؤول حاليًا',
 'Each customer is counted once, even after withdrawal or transfer': 'يُحسب العميل مرة واحدة، حتى بعد سحبه أو نقله',
 'No recorded assignment to a salesperson': 'لا يوجد إسناد مسجل لموظف مبيعات',
 'Historical delivery reporting is pending on the API. These totals show current ownership.': 'تحديث حساب التوزيع التاريخي لم يصل للخادم بعد؛ الأرقام الحالية تعرض الإسناد الحالي فقط.',
 '{0} distributed at least once': '{0} تم توزيعهم مرة على الأقل',
 '{0} currently assigned': '{0} مسندون حاليًا',
 'Current ownership: {0} without a salesperson ({1} in Lead Pool)': 'الحالة الحالية: {0} بدون موظف، منهم {1} في مخزن العملاء',
 'Paid delivered leads ÷ Ever distributed': 'الدافعون ممن سبق توزيعهم ÷ كل من سبق توزيعهم',
 'Duplicate rows': 'الصفوف المكررة',
 'Imported rows': 'الصفوف المستوردة',
 'Valid leads': 'سجلات العملاء الصالحة',
 'Invalid rows': 'الصفوف غير الصالحة',
 'Distributed leads': 'العملاء المسندون حاليًا',
 'Unassigned leads': 'العملاء غير المسندين حاليًا',
 'Assigned sales': 'الموظف المسؤول',
 'Enrolled leads': 'العملاء الحاجزون',
 'Existing CRM lead': 'السجل الأصلي في السيستم',
 'CRM lead': 'سجل العميل',
 'Eligible sales': 'الموظفون المؤهلون للتوزيع',
 'Added to CRM': 'تاريخ دخول السيستم',
 'Unique CRM records from this source': 'سجلات عملاء فريدة من المصدر',
 'Currently assigned; {0} waiting for a work-list slot': 'مسندون حاليًا لموظفين؛ {0} في انتظار مكان بقائمة العمل',
 'No current salesperson; {0} held in Lead Pool': 'بدون موظف حاليًا؛ {0} موقوفون في مخزن العملاء',
 'No current salesperson. These leads may have been assigned before.': 'بدون موظف حاليًا، وقد يكون سبق إسنادهم لموظفين.',
 '{0}–{1} of {2} records': '{0}–{1} من {2} سجلًا',
 'Sheet column': 'عمود الشيت',
 'Map {0}': 'ربط {0}',
 'Timing data unavailable': 'بيانات المدة غير متاحة',
 'Performance cohort: leads updated in the last {0} days.': 'نطاق قياس الأداء: العملاء الذين تم تحديثهم خلال آخر {0} يومًا.',
 'Paid distributed leads ÷ Distributed': 'العملاء الموزعون الدافعون ÷ العملاء الموزعين',
 'Dates use Cairo time. Source is the first source; course is its current mapping.': 'التواريخ بتوقيت القاهرة. المصدر هو أول مصدر، والكورس هو الربط الحالي للمصدر.',
 'Includes waiting. Each phone is counted once in Sales/Mapping history; Reception-only history is not checked.': 'يشمل الانتظار، ويحسب كل رقم مرة في سجل السيلز والـMapping؛ لا يراجع سجل العملاء الموجودين في الريسبشن فقط.',
 'Lead amount for {0}': 'عدد العملاء المرسل إلى {0}',
 'Personal Questions & Extra Data': 'الأسئلة الشخصية والبيانات الإضافية',
 '{0} details': 'تفاصيل {0}',
 'Sample': 'مثال',
 'Branch, area or attendance answer from the source': 'الفرع أو المنطقة أو إجابة نظام الحضور من المصدر',
 'Map branch, area or attendance answers to route leads by the source choices. This warning does not pause importing.': 'اربط إجابات الفرع أو المنطقة أو نظام الحضور لتوزيع العملاء حسب اختيارات المصدر. هذا التنبيه لا يوقف الاستيراد.',
 'All leads without a salesperson, including Lead Pool': 'كل العملاء غير المسندين لموظف، بما فيهم المحجوزون في مخزن العملاء',
 '{0} of the unassigned leads are held in Lead Pool and excluded from distribution.': 'من العملاء غير المسندين، {0} محجوزون في مخزن العملاء ومستبعدون من التوزيع.',
 'Pool status': 'حالة مخزن العملاء',
 'Held in Lead Pool': 'محجوز في مخزن العملاء',
 'Not held in Lead Pool': 'غير محجوز في مخزن العملاء',
 'Row details': 'تفاصيل الصف',
 'Review row': 'مراجعة الصف',
 'Retry this row': 'إعادة معالجة هذا الصف',
 'Row sample': 'عينة بيانات الصف',
 'Import queued for {0}. The summary will refresh when it finishes.': 'تمت إضافة استيراد {0} للطابور. سيتحدث الملخص عند انتهائه.',
 'Could not queue import. Please try again.': 'تعذر إضافة الاستيراد للطابور. حاول مرة أخرى.',
 '{0}: Historical employment dates incomplete — Start Date missing.': '{0}: بيانات التوظيف السابقة غير مكتملة — تاريخ بدء العمل غير مسجل.',
 '{0}: Historical employment dates incomplete — included from documented sales, collection or target in the selected period.': '{0}: بيانات التوظيف السابقة غير مكتملة — تم إدراجه بناءً على مبيعات أو تحصيل أو أهداف موثقة خلال الفترة المحددة.',
 '{0}: inactive tenure cannot be reconstructed without Last Working Date or an employment change record.': '{0}: لا يمكن تحديد فترة العمل السابقة دون تاريخ آخر يوم عمل أو سجل تغيير الحالة الوظيفية.',
 'Receipt #{0}: ambiguous sale identity; excluded from attributed collection.': 'إيصال رقم {0}: تعذر تحديد عملية البيع المرتبطة به؛ تم استبعاده من التحصيل المنسوب للموظف.',
 '{0} historical events have no recorded course identity; excluded from course-filtered conversion metrics.': '{0} أحداث سابقة بدون كورس مسجل؛ تم استبعادها من مؤشرات التحويل المفلترة حسب الكورس.',
 'Payment stage check': 'مراجعة حالة الدفع',
 'Check payment stage': 'مراجعة حالة الدفع',
 'Checking payment stage…': 'جاري مراجعة حالة الدفع…',
 'Check this stage against registered student and receipt evidence.': 'راجع المرحلة حسب تسجيل الطالب والإيصالات الفعلية.',
 'No matching registered student was confirmed. The stage was preserved for manual review.': 'لم يتم تأكيد طالب مسجل مرتبط. تم الحفاظ على المرحلة لحين المراجعة اليدوية.',
 'Payment stage checked against registration and receipts.': 'تمت مراجعة المرحلة حسب التسجيل والإيصالات.',
 'Payment stage check failed.': 'تعذرت مراجعة حالة الدفع.',
 '1. Demo reminder': '١. تذكير بالسيشن',
 '2. Demo feedback': '٢. متابعة الفيدباك',
 'Important follow-up': 'متابعة مهمة',
 'Demo follow-ups are tied to the appointment. Change the Demo booking instead.': 'متابعات السيشن مرتبطة بالحجز. عدّل حجز السيشن بدلًا من ذلك.',
 'Reminder date': 'تاريخ التذكير',
 'Feedback date': 'تاريخ متابعة الفيدباك',
 'Feedback time *': 'وقت متابعة الفيدباك *',
 'Reminder time *': 'وقت التذكير *',
 'Demo reminder': 'تذكير بالسيشن',
 'Demo feedback': 'متابعة فيدباك السيشن',
 'Same day, at least 3 hours before the Demo. You can choose an earlier time.': 'في نفس اليوم، قبل السيشن بـ٣ ساعات على الأقل. يمكنك اختيار وقت أبكر.',
 'Follow up on attendance and feedback the day after the Demo.': 'متابعة الحضور ورأي العميل في اليوم التالي للسيشن.',
 'Choose the Demo appointment first.': 'اختار موعد السيشن أولًا.',
 'Choose a reminder on the appointment day.': 'اختار موعد تذكير في نفس يوم السيشن.',
 'Reminder must be at least 3 hours before the Demo.': 'التذكير لازم يكون قبل السيشن بـ٣ ساعات على الأقل.',
 'Feedback must be on the day after the Demo.': 'متابعة الفيدباك لازم تكون في اليوم التالي للسيشن.',
 ...{
  "Uploading...": "جاري الرفع...",
  "WhatsApp": "واتساب",
  "Course name": "اسم الكورس",
  "Reason": "السبب",
  "Notes": "الملاحظات",
  "Cancel": "إلغاء",
  "Save": "حفظ",
  "Submit Request": "إرسال الطلب",
  "Send": "إرسال",
  "To": "لحد",
  "Subject": "الموضوع",
  "Body": "المحتوى",
  "Unknown": "غير معروف",
  "Edit": "تعديل",
  "Task #": "مهمة رقم",
  "Reset": "إعادة تعيين",
  "Category": "التصنيف",
  "Employee": "الموظف",
  "Course": "الكورس",
  "Stage": "المرحلة",
  "From": "من",
  "s": "ث",
  "Email": "الإيميل",
  "Note": "الملاحظة",
  "Payment": "الدفعة",
  "Other": "أخرى",
  "Today": "النهارده",
  "Clear date range": "مسح فترة التاريخ",
  "Yesterday": "امبارح",
  "This Week": "الأسبوع ده",
  "Custom Range": "فترة مخصصة",
  "Filters": "الفلاتر",
  "Active": "نشط",
  "Branch": "الفرع",
  "Unassigned": "مش متعيّن",
  "EN": "EN",
  "Assigned": "تم التسكين",
  "Status": "الحالة",
  "Clear Filters": "مسح الفلاتر",
  "Tasks": "المهام",
  "Communication": "التواصل",
  "History": "السجل",
  "Source": "المصدر",
  "Details": "التفاصيل",
  "Open WhatsApp": "فتح WhatsApp",
  "Next": "التالي",
  "Free Session": "حصة مجانية",
  "Scheduled": "مجدول",
  "Courses": "الكورسات",
  "Groups": "المجموعات",
  "Comments": "التعليقات",
  "Bank Transfer": "تحويل بنكي",
  "Completed": "مكتمل",
  "Found": "اتلاقى",
  "Not found": "مش موجود",
  "Amount": "المبلغ",
  "Awaiting approval": "مستني موافقة",
  "No installment due within 30 days.": "مفيش قسط مستحق خلال 30 يوم.",
  "Try again": "حاول تاني",
  "Registration": "التسجيل",
  "Cash": "نقدي",
  "Installment": "قسط",
  "Number of Installments": "عدد الأقساط",
  "EGP": "ج.م",
  "Paid Amount": "المبلغ المدفوع",
  "Total Course Price": "سعر الكورس بالكامل",
  "Course Name": "اسم الكورس",
  "Payment Method": "طريقة الدفع",
  "Receipt preview": "معاينة الإيصال",
  "(Optional)": "(اختياري)",
  "Answered": "اتجاوب",
  "No Answer": "مفيش إجابة",
  "Select course": "اختار الكورس",
  "Download PDF": "تنزيل PDF",
  "Phone": "الموبايل",
  "Available": "متاح",
  "Used": "المستخدم",
  "Student #": "طالب رقم",
  "Overdue": "متأخر",
  "Reason:": "السبب:",
  "Enter amount": "اكتب المبلغ",
  "Payment method": "طريقة الدفع",
  "Receipt": "الإيصال",
  "Remove": "إزالة",
  "Retry": "حاول تاني",
  "Ready to register": "جاهز للتسجيل",
  "Saving…": "جاري الحفظ…",
  "Required": "مطلوب",
  "Priority": "الأولوية",
  "Back": "رجوع",
  "Refresh": "تحديث",
  "Select": "اختار",
  "Previous": "السابق",
  "This month": "الشهر ده",
  "Done": "تمت",
  "Search": "بحث",
  "Type": "النوع",
  "Date": "التاريخ",
  "Not recorded": "مش متسجل",
  "View": "عرض",
  "Close": "إغلاق",
  "Unavailable": "مش متاح",
  "Needs Review": "محتاج مراجعة",
  "Open": "فتح",
  "Review": "مراجعة",
  "Reject": "رفض",
  "Booked": "محجوز",
  "Period": "الفترة",
  "All branches": "كل الفروع",
  "Needs action": "محتاج إجراء",
  "All Branches": "كل الفروع",
  "All Employees": "كل الموظفين",
  "All Courses": "كل الكورسات",
  "N/A": "غير متاح",
  "record": "سجل",
  "records": "سجلات",
  "Failed": "فشل",
  "Evidence": "دليل التحقق",
  "Continue": "كمّل",
  "All": "الكل",
  "Unread": "لسه ما اتقراش",
  "Requests": "الطلبات",
  "Dismiss": "قفل",
  "Month": "الشهر",
  "This Month": "الشهر ده",
  "Registrations": "التسجيلات",
  "Clear": "مسح",
  "Needs attention": "محتاج اهتمام",
  "Live": "مباشر",
  "Advanced Filters": "فلاتر إضافية",
  "Registered": "متسجل",
  "Overview": "نظرة عامة",
  "Settings": "الإعدادات",
  "Section": "القسم",
  "Due date": "تاريخ الاستحقاق",
  "Apply": "تطبيق",
  "Show": "عرض",
  "Waiting": "الانتظار",
  "Compact": "مختصر",
  "Sales": "المبيعات",
  "Collected": "اتحصّل",
  "Progress": "التقدم",
  "Remaining": "الباقي",
  "Arabian Academy": "أريبيان أكاديمي",
  "Choose course": "اختار الكورس",
  "No phone": "مفيش رقم موبايل",
  "Urgent": "عاجل",
  "Note (optional)": "ملاحظة (اختياري)",
  "Save Changes": "حفظ التعديلات",
  "Students": "الطلاب",
  "Action": "الإجراء",
  "View Details": "عرض التفاصيل",
  "Range": "النطاق",
  "Score": "الدرجة",
  "Approve": "موافقة",
  "Decision": "القرار",
  "Course / Program": "الكورس / البرنامج",
  "Start Date": "تاريخ البداية",
  "End Date": "تاريخ النهاية",
  "Revenue": "الإيرادات",
  "Description": "الوصف",
  "Count": "العدد",
  "Complete": "مكتمل",
  "Course filter": "فلتر الكورس",
  "Task Type": "نوع المهمة",
  "High": "عالي",
  "Medium": "متوسط",
  "Low": "منخفض",
  "Unknown error": "خطأ غير معروف",
  "Upcoming": "جاي",
  "Current Stage": "المرحلة الحالية",
  "Payment Pending": "في انتظار تأكيد الدفع",
  "Confirm": "تأكيد",
  "Requested": "مطلوب",
  "All statuses": "كل الحالات",
  "Created from": "اتعمل من تاريخ",
  "Created to": "اتعمل لحد تاريخ",
  "Capacity": "السعة",
  "Pending": "قيد الانتظار",
  "Approved": "موافق عليه",
  "Rejected": "مرفوض",
  "Created": "اتعمل",
  "Request #": "طلب رقم",
  "Queue": "الطابور",
  "Created Date": "تاريخ الإنشاء",
  "Paid": "مدفوع",
  "Total": "الإجمالي",
  "No response data": "مفيش بيانات إجابة",
  "Name": "الاسم",
  "Attempts": "المحاولات",
  "to": "لحد",
  "Actions": "الإجراءات",
  "Manual": "يدوي",
  "Reception": "الاستقبال",
  "Super Reception": "مشرف الاستقبال",
  "Instructor": "المدرب",
  "Mentor": "الموجّه",
  "HR": "الموارد البشرية",
  "Marketing": "التسويق",
  "Accountant": "الحسابات",
  "Classification": "التصنيف",
  "Error": "خطأ",
  "Ready": "جاهز",
  "Reset filters": "إعادة ضبط الفلاتر",
  "Import": "استيراد",
  "Saving...": "جاري الحفظ...",
  "Instapay": "إنستاباي",
  "Vodafone Cash": "فودافون كاش",
  "Finished": "خلص",
  "Running": "جاري"
},
 ...salesArabicTranslations,
 ...targetsArabicTranslations,
 ...operationsArabicTranslations,
 ...employeeArabicTranslations,
 ...supplementArabicTranslations,
 ...finalOperationsArabicTranslations,
 ...finalEmployeeArabicTranslations,
 ...leadMovementArabicTranslations,
 ...dashboardAuditArabicTranslations,
 ...targetsAuditArabicTranslations,
 ...shellAuditArabicTranslations,
 ...operationsAuditArabicTranslations,
 ...addLeadArabicTranslations,
};
export const salesEnglishCatalog: Record<string,string> = {
  vodafone_cash: 'Vodafone Cash',
  bank_transfer: 'Bank Transfer',
  instapay: 'InstaPay',
  cash: 'Cash',
 ...{
  "المهام": "Tasks",
  "التواصل": "Communication",
  "واتساب": "WhatsApp",
  "السجل": "History",
  "إعادة المحاولة": "Retry",
  "المرحلة الحالية": "Current Stage",
  "تاريخ الإنشاء": "Created Date",
  "السابق": "Previous",
  "التالي": "Next",
  "إلغاء": "Cancel"
},
 ...Object.fromEntries(Object.entries(salesArabicCatalog).map(([en,ar]) => [ar,en])),
 ...salesEnglishTranslations,
 ...targetsEnglishTranslations,
 ...operationsEnglishTranslations,
 ...employeeEnglishTranslations,
 ...supplementEnglishTranslations,
 ...finalOperationsEnglishTranslations,
 ...finalEmployeeEnglishTranslations,
 ...leadMovementEnglishTranslations,
 ...dashboardAuditEnglishTranslations,
 ...targetsAuditEnglishTranslations,
 ...shellAuditEnglishTranslations,
 ...operationsAuditEnglishTranslations,
};
